import BottomSheetHeader from '@components/BottomSheetHeader';
import Button from '@components/Button';
import Column from '@components/Column';
import FileUploader from '@components/FileUploader';
import Note from '@components/Note';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import useToast from '@hooks/ui/useToast';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { ChangeEventHandler, useState } from 'react';
import Tesseract from 'tesseract.js';

import styles from './styles.module.scss';

const codeExp = /^\d{4} \d{4} \d{4} \d{4}$/;

const NewGiftBottomSheet: ActivityComponentType = () => {
  const toast = useToast();
  const [isOcr, setIsOcr] = useState<boolean>(true);
  const handleFileChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const imagePath = URL.createObjectURL(e.target.files![0]);
    Tesseract.recognize(imagePath, 'eng+kor')
      .then((res) => {
        const { text } = res.data;
        const rows = text.split('\n');
        const code = rows.find((row) => codeExp.test(row));
        if (code) {
          toast.success(`쿠폰 코드가 인식되었습니다. ${code}`);
        } else {
          toast.error('쿠폰 코드가 인식되지 않았습니다. 다시 시도해주세요.');
        }
      })
      .catch((error: unknown) => {
        console.error(error);
        toast.error('이미지 인식에 실패했습니다.');
      });
  };
  return (
        <BottomSheet>
            <BottomSheetHeader>
                새 선물 등록
            </BottomSheetHeader>
            <Column className={styles.container} spacing={32}>
                <Row fullWidth justify='flex-end'>
                    <Switch checked={!isOcr}
                            setChecked={() => setIsOcr(!isOcr)}
                            leftText='이미지 등록'
                            rightText='직접 입력' />
                </Row>
                {isOcr ? (
                    <Column fullWidth spacing={12}>
                        <Text size='lg' fontWeight='bold' color={colors.gray7}>
                            이미지 파일 업로드
                        </Text>
                        <FileUploader onChange={handleFileChange}/>
                    </Column>
                ) : (
                    <TextField placeholder="'-'없이 숫자만 입력해주세요."
                               inputMode='numeric'
                    />
                )}

                <Note title='유의사항'>
                    유효기간이 지났거나 부정한 방법으로 만든 쿠폰은 사용하실 수 없습니다. (내용 임의 텍스트)
                </Note>
                <Button fullWidth>등록</Button>
            </Column>
        </BottomSheet>
  );
};

export default NewGiftBottomSheet;
